module.exports = __webpack_public_path__ + "img/symbol_10.dfc2de35.png";